import React from "react";

export default function Cart({ product }) {
  console.log(product);
  return (
    <div>
      <h1>This is Cart Page</h1>
    </div>
  );
}
